import { yupResolver } from "@hookform/resolvers/yup";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Grid, Tab } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  EstadosOrdenTrabajoEnumChoice,
  ROUTER_PATHS,
  useTabsFormOnly,
} from "@/shared";
import {
  OrdenTrabajoQueryKeysEnum,
  useFetchUbicacionProductosEnabled,
  // useUpdateContrato,
} from "@/shared/actions/erp";
import {
  CustomButtunsRejectConfirm,
  CustomTabPanel,
  FormTabsOnly,
  SingleIconButton,
  TabsFormBoxScene,
} from "@/shared/components/ui";
import {
  ONTOption,
  OrdenTrabajo,
} from "@/shared/interfaces";
import { a11yProps, ordenTrabajoSubeTecnicoFormSchema, texto } from "@/shared/utils";
import { useEquiposAdicionales, useMaterialesUtilizadosStore } from "@/store/erp";
import { useUiConfirmModalStore } from "@/store/ui";
import OTDetalleClienteInstallTecnicoFormTab from "./OTDetalleClienteInstallTecnicoFormTab";
import OTInstalacionTecnicoFormTab from "./OTInstalacionTecnicoFormTab";
import OTMaterialesInstallTecnicoFormTab from "./OTMaterialesInstallTecnicoFormTab";
import dayjs from "dayjs";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { CategoryProducCodeEnum } from "@/shared/interfaces/erp/inventario";


export interface RevisionOrdenTrabajoTecProps {
  title: string;
  ordentrabajo: OrdenTrabajo;
}

const RevisionOrdenTrabajoTec: React.FC<
  RevisionOrdenTrabajoTecProps
> = ({ title, ordentrabajo }) => {
  const navigate = useNavigate();
  const returnUrlInstalacionesTecnicoPage =
    ROUTER_PATHS.tecnico.ordenenTrabajoNav;
  ///* hooks -----------------------
  const [optionsONT, setOptionsONT] = useState<ONTOption[]>([]);
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });
  const queryClient = useQueryClient();

  // ================== EQUIPOS ==================
  // useEquiposDisponiblesFlotaOT({
  //   id: ordentrabajo.id_orden_trabajo,
  //   flota_data: ordentrabajo.flota_data,
  // });
  const clearAllMaterials = useMaterialesUtilizadosStore(
    (s) => s.clearAllMaterials
  );

  // ================== EQUIPOS --- END ==================

  ///* local state -----------------------
  const [shrink] = useState(true);

  ///* global state -----------------------
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );
  const {
    setProductos: setMaterialesUtilizados
  } = useCargarSeriesProductos()
  const setProductosAdicionales = useEquiposAdicionales(s => s.setProductos)

  ///* form -----------------------
  //const form = useForm<SaveFormDataInstallTecAsig>({
  const form = useForm<any>({
    resolver: yupResolver(ordenTrabajoSubeTecnicoFormSchema) as any,
    defaultValues: {
      estado: true,
      es_conexion_tierra: false,
      es_regulador: false,
      ont_a_utilizar: ordentrabajo?.equipos_utilizados?.[0] || "",
    },
  });

  const {
    reset,
    formState: { errors },
  } = form;


  const {
    data: dataUbicacionProd,
    isLoading: isloadingUbProducto,
    // isRefetching: isRefetchingUbProducto
  } = useFetchUbicacionProductosEnabled({
    enabled: true,
    params: {
      page_size: 1000,
      page: 1,
      categoria_producto: CategoryProducCodeEnum.EQUIPOS,
      ubicacion: ordentrabajo?.flota_data?.ubicacion,
      // filterByState: false
    }
  });
  // useEffect(()=>{
  //   // const corporatePlansFiltered = paymentMethodsFilterPaging?.filter((x)=>x.nombre.includes("DÉBITO") || x.nombre.includes("TRANSFERENCIA") || x.nombre.includes("CONTRAFACTURA") || x.nombre.includes("OTRO")) || []
  //   getpaymentMethodsFilterPaging()
  //   setPaymentMethods(paymentMethodsFilterPaging)

  // },[paymentMethodsFilterPaging])




  const refreshData = async () => {
    await queryClient.invalidateQueries({
      queryKey: [
        OrdenTrabajoQueryKeysEnum.OrdenTrabajo,
        ordentrabajo?.id_orden_trabajo?.toString() || "",
      ],
    });
  };

  const resetFormWithOTData = (ordenTrabajo: OrdenTrabajo) => {
    if (!ordenTrabajo?.id_orden_trabajo) return;

    const { prospecto_data, preventa_data, agendamiento_data, ...rest } =
      ordenTrabajo;
    delete rest?.contrato_data;
    if (ordenTrabajo?.materiales_utilizados?.length > 0) {
      setMaterialesUtilizados(ordenTrabajo?.materiales_utilizados as any[] || [])
    }
    if (ordenTrabajo?.materiales_equipos_adicionales?.length > 0) {
      setProductosAdicionales(ordenTrabajo?.materiales_equipos_adicionales as any[] || [])
    }

    ///* reset form -------------
    reset({
      ...prospecto_data,
      ...preventa_data,
      ...agendamiento_data,
      ...rest,
      planLabel: ordenTrabajo?.plan_data?.nombre || "",
      flotaLabel: ordenTrabajo?.flota_data?.nombre || "",
      tipo_instalacion: ordenTrabajo?.tipo_instalacion || preventa_data?.tipo_instalacion || "",
      subtipo_instalacion: ordenTrabajo?.subtipo_instalacion || "",
      valor_instalacion: preventa_data?.valor_instalacion || "",
      observacion_activacion:
        ordenTrabajo?.observaciones?.observacion_activacion,

      observacion_1: ordenTrabajo?.preventa_data?.observaciones?.observacion_1,
      observacion_2: ordenTrabajo?.preventa_data?.observaciones?.observacion_2,
      observacion_tecnico: ordenTrabajo?.observaciones?.observacion_tecnico || "",
      observacion_llamada:
        agendamiento_data?.observaciones?.observacion_llamada,

      metraje_autorizado: rest?.ciudad_data?.metraje_autorizado || "0",

      es_conexion_tierra: !!rest?.es_conexion_tierra,
      es_regulador: !!rest?.es_regulador,

      ///* Activacion ---
      rawNap: rest.nap_data,
      nap: rest.nap || "",
      ont_a_utilizar: rest?.equipos_utilizados?.[0] || "",
      puntos_red_instalados: rest?.puntos_red_instalados || "0",
      puntos_red_no_instalados: rest?.puntos_red_no_instalados || "0",
      routers_adicionales_instalados: rest?.routers_adicionales_instalados || 0,
      forma_pago_adicionales_tecnico: rest?.forma_pago_adicionales_tecnico || null,


      ...(ordenTrabajo?.forma_pago_adicionales_tecnico
        && Object.keys(ordenTrabajo?.forma_pago_adicionales_tecnico).length > 0
        && {
        forma_pago_aux: form.getValues()?.forma_pago_adicionales_tecnico?.forma_pago,
        metodo_pago_mensualidad_aux: form.getValues()?.forma_pago_adicionales_tecnico?.metodo_pago_mensualidad,
        valor_instalacion_total_aux: form.getValues()?.forma_pago_adicionales_tecnico?.valor_instalacion_total,
        valor_instalacion_aux: form.getValues()?.forma_pago_adicionales_tecnico?.valor_instalacion,
        valor_instalacion_iva_aux: form.getValues()?.forma_pago_adicionales_tecnico?.valor_instalacion_iva,
        numero_cuenta_aux: form.getValues()?.forma_pago_adicionales_tecnico?.numero_cuenta,
        tipo_cuenta_bancaria_aux: form.getValues()?.forma_pago_adicionales_tecnico?.tipo_cuenta_bancaria,
        numero_tarjeta_aux: form.getValues()?.forma_pago_adicionales_tecnico?.numero_tarjeta,
        entidad_financiera_aux: form.getValues()?.forma_pago_adicionales_tecnico?.entidad_financiera,
        codigo_forma_pago_aux: form.getValues()?.forma_pago_adicionales_tecnico?.codigo_forma_pago,
        tipo_contrato_aux: form.getValues()?.forma_pago_adicionales_tecnico?.tipo_contrato,
        tarjeta_aux: form.getValues()?.forma_pago_adicionales_tecnico?.tarjeta,
      }
      ),
      equipos_adicionales_preventa: ordenTrabajo?.preventa_data?.equipos_adicionales || null

      //} as unknown as SaveFormDataInstallTecAsig);
    } as unknown as any);
    // if( 
    //   ordenTrabajo?.materiales_equipos_adicionales?.length>0
    //   || ((ordenTrabajo?.preventa_data?.equipos_adicionales?.length||0)>0)
    // ){
    //   setProductosAdicionales(
    //     ordenTrabajo?.materiales_equipos_adicionales
    //     ||ordenTrabajo?.preventa_data?.equipos_adicionales
    //     ||[]
    //   )
    // }
  };

  ///* effects -----------------------
  useEffect(() => {
    setMaterialesUtilizados([])
    setProductosAdicionales([])
    setProductosAdicionales(
      ordentrabajo?.materiales_equipos_adicionales
      || [])
  }, [])
  useEffect(() => {
    if (!ordentrabajo?.id_orden_trabajo) return;

    resetFormWithOTData(ordentrabajo);
  }, [ordentrabajo]);
  useEffect(() => {
    const auxONTOptions = dataUbicacionProd?.data?.data?.map((item) => {
      console.log({ itemdesupuestaont: item })
      const auxONT = item.series
      const auxONTData: any[] = []
      if (item.producto_data?.es_ont && auxONT?.length > 0) {
        auxONT.forEach((ont) => {
          console.log({ item })
          const auxONTSplit = ont.split('-')
          auxONTData.push({
            name: `${item.producto_data?.descripcion} - ${auxONTSplit[0]}`,
            codigo: item.producto_data?.codigo,
            cantidad: "1",
            series: [ont],
          })
        })
        return auxONTData
      }
      return null
    })?.filter((x) => x != null)
    console.log({ auxONTOptions })
    setOptionsONT(auxONTOptions?.flat() || []);

    if (!form.getValues().ont_a_utilizar) return;

    form.reset({
      ...form.getValues(),
      ont_a_utilizar: form.getValues()?.equipos_utilizados?.[0] || {}
    })

  }, [isloadingUbProducto, dataUbicacionProd]);

  return (
    <TabsFormBoxScene
      titlePage={title}
      showBtns={false}
      // // custom btns ---------
      showCustomBtns={true}
      customBtns={
        <CustomButtunsRejectConfirm
          // confirmTextBtn={isCorrentingData ? "Actualizar" : "Guardar"}
          showRejectBtn={false}
          showConfirmBtn={false}
          // rejectTextBtn={"Rechazar actividad"}
          onCancel={() => {
            setConfirmDialogIsOpen(false);
            clearAllMaterials();
            navigate(returnUrlInstalacionesTecnicoPage);
          }}
          //  ----------- CONFIRMAR -----------
          onConfirm={()=>{}}
          //  ----------- RECHAZAR -----------
          onReject={() => {
          }}
          // auxiliar btn (refresh) ----------------
          showAuxiliarBtn={true}
          auxiliarBtn={
            <SingleIconButton
              label="Actualizar"
              color="success"
              startIcon={<RefreshIcon />}
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: "Refrescar Datos",
                  subtitle:
                    "Al refrescar los datos se perderán los cambios realizados. ¿Desea continuar?",
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    refreshData();
                  },
                  confirmTextBtn: "SI",
                  cancelTextBtn: "NO",
                });
              }}
            />
          }
        />
      }
      // // tabs ---------
      tabs={<>
        {
          form.getValues()?.observaciones?.observacion_actualizacion_tecnico
            && form.getValues()?.estado_orden_trabajo === EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR ?
            <Grid container spacing={2} justifyContent={"center"} my={2}>
              <CustomAlertCard
                alertTitle="Actualización solicitada por Auditoría"
                alertMessage={`${texto.correccion_solicitada_tecnico_auditoria} \n ${form.getValues()?.motivo_rechazo_data?.nombre}: ${form.getValues()?.observaciones?.observacion_actualizacion_tecnico} (${dayjs(form.getValues()?.observaciones?.fecha_solicitada_actualizacion_tecnico).format("DD/MM/YYYY HH:mm:ss") || "Fecha no definida"})`}
                bgColorAlert="RED"
                alertColor="error" />
            </Grid>
            : null
        }
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="ORDEN TRABAJO" value={1} {...a11yProps(1)} />
          <Tab label="INFORMACIÓN CLIENTE" value={2} {...a11yProps(2)} />
          <Tab label="MATERIALES" value={3} {...a11yProps(3)} />
        </FormTabsOnly>
      </>
      }
    >
      {/* ===================== ORDEN TRABAJO ===================== */}
      <CustomTabPanel index={valueTab} value={1}>
        <OTInstalacionTecnicoFormTab
          form={form}
          errors={errors}
          shrink={shrink}
        />
      </CustomTabPanel>

      {/* ===================== DETALLES DE INSTALACIÓN ===================== */}
      {/* <CustomTabPanel index={valueTab} value={2}>
        <OTDetalleInstallTecnicoFormTab
          form={form}
          errors={errors}
          shrink={shrink}
          coords={ordentrabajo?.agendamiento_data?.coordenadas || ""}
          ordenTrabajo={ordentrabajo!}
          isOnlyView={true}
          canDragMarker
          canRuler
        />
      </CustomTabPanel> */}

      {/* ===================== DETALLES CLIENTE ===================== */}
      <CustomTabPanel index={valueTab} value={2}>
        <OTDetalleClienteInstallTecnicoFormTab
          form={form}
          errors={errors}
          shrink={shrink}
        // isOnlyView={true}
        />
      </CustomTabPanel>

      {/* ===================== MATERIALES ===================== */}
      <CustomTabPanel index={valueTab} value={3}>
        <OTMaterialesInstallTecnicoFormTab
          form={form}
          ordenTrabajo={ordentrabajo!}
          optionsONT={optionsONT}
          isloadingUbProducto={isloadingUbProducto}
        />
      </CustomTabPanel>

      {/* =================== DIALOGS =================== */}
      {/* <RejectInstalacionAsigTecModal
        open={openRejectModal}
        setOpen={setOpenRejectModal}
        idOrdenTrabajo={ordentrabajo?.id_orden_trabajo!}
        observacionesOrdenTrabajo={ordentrabajo?.observaciones}
      //ordenTrabajo={ordentrabajo!}
      /> */}
    </TabsFormBoxScene>
  );
};

export default RevisionOrdenTrabajoTec;
